<template>
  <span class="tag-input-wrapper">
    <div class="tag-wrapper">
      <Tag :text="tag" v-for="(tag, index) in tags" @onClickDelete="onDeleteTag" :key="index" :index="index"/>
    </div>
    <input v-model="data" type="text" class="data-input" @keyup.enter="onEnter" @keyup.backspace="onBackspace"></input>
    <mu-button icon small @click="onSubmit">
      <mu-icon value="check" />
    </mu-button>
  </span>
</template>

<script>
import Tag from './Tag.vue'

export default {
  name: "TagInput",
  components: {
    Tag
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      tags: this.value.slice(0),

      data: "",
    }
  },
  computed: {

  },
  watch: {
    data(newValue) {
      this.onChangeData(newValue);
    }
  },
  methods: {
    input() {
      this.$emit('input', this.tags);
    },
    onDeleteTag(key) {
      this.tags.splice(key, 1);
      this.input();
    },
    onChangeData(newValue) {
      if(typeof newValue !== 'undefined') {
        var splitted = newValue.split(" ");
        if(splitted.length > 1) {
          for (var i = 0; i < splitted.length - 1; i++) {
            this.tags.push(splitted[i]);
          }
          this.data = splitted[splitted.length];
        }
      }
      this.input();
    },
    onEnter() {
      if(typeof this.data !== 'undefined' && this.data !== "") {
        this.tags.push(this.data);
        this.data = "";
        this.input();
      }
    },
    onBackspace() {
      if(typeof this.data === 'undefined' || this.data === "") {
        this.data = this.tags[this.tags.length - 1];
        this.tags.splice(this.tags.length - 1, 1);
        this.input();
      }
    },
    onSubmit() {
      if(typeof this.data !== 'undefined' && this.data !== "") {
        this.tags.push(this.data);
        this.data = "";
        this.input();
      }
      this.$emit('onSubmit');
    }
  }
};
</script>

<style scoped>
.data-input {
  border: 0px;
  background-color: transparent;
  display:inline-block;
  height: 34px;
  flex: 1;
}
.data-input:focus {
  background-color: transparent;
  outline: none;
}
.tag-wrapper {
  margin-top: 1px;
  margin-right: 8px;
}
.tag-input-wrapper {
  border: 1px solid #ccc;
  border-radius: 8px 0px 0px 8px;
  background-color: #FFFFFF;
  display: flex;
  height: 36px;
}
</style>
